import { create } from 'zustand';
import { randomId } from '../shared/random-id';

export type ToastType = 'error' | 'success' | 'warning';

export interface Toast {
  id: string;
  type: ToastType;
  message: string;
}

const DURATION: Record<ToastType, number> = {
  error:   5000,
  warning: 4000,
  success: 3000,
};

interface ToastState {
  toasts: Toast[];
  show: (type: ToastType, message: string) => void;
  dismiss: (id: string) => void;
}

export const useToastStore = create<ToastState>((set, get) => ({
  toasts: [],

  show: (type, message) => {
    const id = randomId();
    // Keep max 3 toasts — oldest drops off
    set((s) => ({ toasts: [...s.toasts.slice(-2), { id, type, message }] }));
    setTimeout(() => get().dismiss(id), DURATION[type]);
  },

  dismiss: (id) => {
    set((s) => ({ toasts: s.toasts.filter((t) => t.id !== id) }));
  },
}));
